/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardBill200ResponseLatestStatus } from './get-card-bill200-response-latest-status';

/**
 * 
 * @export
 * @interface GetCardBill200Response
 */
export interface GetCardBill200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'cardBillId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'paymentType': GetCardBill200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'allocateAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'amountBeforePointDiscount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'billingAmount': number;
    /**
     * 
     * @type {GetCardBill200ResponseLatestStatus}
     * @memberof GetCardBill200Response
     */
    'latestStatus': GetCardBill200ResponseLatestStatus;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'supplierName': string;
}

export const GetCardBill200ResponsePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetCardBill200ResponsePaymentTypeEnum = typeof GetCardBill200ResponsePaymentTypeEnum[keyof typeof GetCardBill200ResponsePaymentTypeEnum];


